import { Input, InputProps } from 'antd';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { Search } from 'components/icons';

import s from './search-input.module.scss';

/** Поле поиска для тулбаров списков: иконка лупы, очистка, высота как у кнопок */
export const SearchInput = ({ placeholder = 'Search...', className, ...props }: InputProps) => {
  const { t } = useTranslation();

  return (
    <Input
      allowClear
      prefix={<Search className={s.icon} />}
      placeholder={t(placeholder)}
      className={cx(s.input, className)}
      {...props}
    />
  );
};
